import { render, staticRenderFns } from "./como-funciona.vue?vue&type=template&id=730fb3df&scoped=true&"
import script from "./como-funciona.vue?vue&type=script&lang=js&"
export * from "./como-funciona.vue?vue&type=script&lang=js&"
import style0 from "./como-funciona.vue?vue&type=style&index=0&id=730fb3df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730fb3df",
  null
  
)

export default component.exports